module.exports = __webpack_public_path__ + "img/img (12).4fa24596.jpg";